import Button from "../common/Button";
import Spinner from "../common/Spinner";
import Error from "../Error";
import AuthContext from "./AuthContext";
import useLogin from "./useLogin";

const AuthLogin = ({ children }) => {
	const { isAuthenticated, isLoading, error, token } = useLogin();
	if (error) {
		return (
			<div className="flex justify-center items-center">
				<div className="flex flex-col gap-4 max-w-3xl">
					<Error>{`Authentication error: ${error.message}`}</Error>
					<Button onClick={() => (window.location = "/")}>
						Retry
					</Button>
				</div>
			</div>
		);
	}
	if (!isAuthenticated || isLoading) {
		return <Spinner centered />;
	}
	return <AuthContext token={token}>{children}</AuthContext>;
};

export default AuthLogin;
